<template>
  <div class="mb-0 px-3 w-1/2 flex flex-wrap items-center justify-center md:justify-end">
    <div class="font-normal text-primary-text pr-3">{{ sortByText }}</div>
    <div class="relative max-w-xxxs">
      <select
        :sorting.sync="sorting"
        @change="$emit('update:sorting', $event.target.value)"
        class="block appearance-none w-full bg-transparent pr-12 focus:outline-none font-normal text-primary-text tracking-slight lg:hover:text-action cursor-pointer"
      >
        <option v-for="(option, value) in options" :key="value" :value="option.value" :selected="option.value === sorting">{{ option.title }}</option>
      </select>
      <div class="pointer-events-none absolute pin-y pin-r flex items-center text-secondary-text">
        <span class="h-4 inline-block text-secondary-text">
          <svg class="stroke-current h-3 w-3" viewBox="0 0 768 768">
            <path fill="none" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="4" stroke-width="96" d="M95.999 240l288.001 288.001 288.001-288.001"></path>
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'SearchSorting',
  props: {
    sorting: {
    },
    options: {
    },
    sortByText: {
      type: String,
      default: ''
    }
  },
  options: {
    type: Object,
    default: [],
    required: true,
  }
};
</script>
